/* eslint-disable no-unused-vars */

import { useState, useContext, useEffect } from "react";
import axios from "axios";
import { API_URL, showAlert, AuthContext } from "../util/api";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../header";
import Footer from "../footer";
import "./register_new.css";

const Register = () => {
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [storeCode, setStoreCode] = useState("");
  const [loading, setLoading] = useState(false);

  const queryParams = new URLSearchParams(window.location.search);
  const code = queryParams.get("code");

  useEffect(() => {
    if (code) setStoreCode(code);
  }, [code]);

  const sendVerificationCode = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${API_URL}/send-verification-code`,
        { email }
      );

      if (response.data.status === "successful") {
        setStoreCode(response.data.code);
        showAlert("success", "Success!", "Verification code sent to your email.");
      } else {
        showAlert("error", "Error!", response.data.message);
      }
    } catch {
      showAlert("error", "Error!", "Failed to send verification code.");
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();

    if (!verificationCode)
      return showAlert("error", "Error!", "Enter verification code.");

    if (verificationCode != storeCode)
      return showAlert("error", "Error!", "Invalid verification code.  ");

    if (password !== confirmPassword)
      return showAlert("error", "Error!", "Passwords do not match.");

    try {
      setLoading(true);
      const response = await axios.post(`${API_URL}/auth/register`, {
        name,
        email,
        password,
      });

      if (response.data.status === "successful") {
        login(response.data.token, response.data.user);
        showAlert("success", "Success!", "Registration successful!");
        navigate("/select-role");
      } else {
        showAlert("error", "Error!", response.data.message);
      }
    } catch {
      showAlert("error", "Error!", "Registration failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar menuColor="red" />

      <div className="register-wrapper">
        <div className="register-card">

          {/* LEFT */}
          <div className="register-left">
            <h1>Create Account</h1>
            <p>
              Join our platform to access healthcare professionals,
              appointments, and personalised services.
            </p>
          </div>

          {/* RIGHT */}
          <div className="register-right">
            <h2>Register</h2>

            <form onSubmit={handleRegister}>
              <div className="input-group">
                <input required value={name} onChange={(e) => setName(e.target.value)} />
                <label>Full Name</label>
              </div>

              <div className="input-group">
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <label>Email Address</label>
              </div>

              <div className="verify-row">
                <div className="input-group">
                  <input
                    value={verificationCode}
                    onChange={(e) => setVerificationCode(e.target.value)}
                  />
                  <label>Verification Code</label>
                </div>

                <button
                  type="button"
                  className="code-btn"
                  onClick={sendVerificationCode}
                  disabled={loading || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)}
                >
                  {loading ? "Sending..." : "Get Code"}
                </button>
              </div>

              <div className="input-group">
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <label>Password</label>
              </div>

              <div className="input-group">
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <label>Confirm Password</label>
              </div>

              <button className="register-btn" disabled={loading}>
                {loading ? "Creating account..." : "Register"}
              </button>
            </form>

            <p className="terms">
              By registering, you agree to our{" "}
              <Link to="/terms-and-conditions">Terms & Conditions</Link>
            </p>

            <div className="login-link">
              Already have an account? <Link to="/login">Login</Link>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Register;
